<div class="flex flex-col h-100-percent service-def-header">
  <div class="header pl-72 pr-72 pb-24">
    <app-breadcrumb [items]="breadcrumbItems" class="mt-16 pl-20"></app-breadcrumb>
    <div class="flex flex-row">
      <mat-icon svgIcon="arrow_back" class="icon-md-1 cursor-pointer mt-8" (click)="previous()"></mat-icon>
      <div class="flex flex-col ml-24">
        <div class="mat-subtitle-1 fw-600 mb-0" *ngIf="!blueprintId">{{sandbox ? ('CREATE_SERVICE.CREATE_SANDBOX' | transloco) : ('CREATE_SERVICE.CREATE_SERVICE_DEFINITION' | transloco) }}</div>
        <div class="mat-subtitle-1 fw-600 mb-0" *ngIf="blueprintId">{{ sandbox ? ('CREATE_SERVICE.UPDATE_SANDBOX' | transloco) : ('CREATE_SERVICE.UPDATE_SERVICE' | transloco) }}</div>
        <div class="flex flex-row mt-4">
          <span class="fw-600 mr-4">{{'INSTANCE_DETAILS.SOLUTION' | transloco}}:</span>
          <span>{{ !blueprintId ? getSelectedVersion?.name : getSelectedVersionExtend?.name }}</span>
          <div class="flex flex-row justify-center items-center vertical-indicator ml-6 h-18 mt-4">
            <span class="mr-10 ml-6">
              <span class="fw-600">{{'INSTANCE_DETAILS.SOLUTION_VERSION' | transloco}}</span>:
              {{!blueprintId ? (getSelectedVersion?.releaseVersion ? getSelectedVersion?.releaseVersion : ('CREATE_SERVICE.NO_RELEASE' | transloco)) : (getSelectedVersionExtend?.releaseVersion ? getSelectedVersionExtend?.releaseVersion : ('CREATE_SERVICE.NO_RELEASE' | transloco))}}
            </span>
          </div>
        </div>
      </div>


      <!-- <div class="flex flex-col">
        <div class="mat-subtitle-1 fw-600 mb-0">{{'CREATE_SERVICE.CREATE_SERVICE_DEFINITION' | transloco}}</div>
        <div *ngIf="!isLoading; else solutionNameLoader" class="flex flex-row mt-4">
          <span class="fw-600 mr-4">{{'INSTANCE_DETAILS.SOLUTION' | transloco}}:</span>
          <span>{{ solution?.name }}</span>
        <div class="flex flex-row justify-center items-center vertical-indicator ml-6 h-18 mt-4">
          <span class="mr-10 ml-6">
            <span class="fw-600">{{'BLUEPRINT_SUMMARY.RELEASE' | transloco}}</span>:
            {{(latestSolutionVersion?.releaseVersion ? latestSolutionVersion?.releaseVersion : ('CREATE_SERVICE.NO_RELEASE' | transloco))}}
          </span>
        </div>
        </div>
      </div> -->


    </div>
  </div>
  <div class="basis-full ml-72 mr-72 mt-24">
    <div class="mb-20 flex flex-col">

      <div class="flex items-center steper-section">
        <div *ngIf="blueprintForm" class="flex items-center justify-center" [ngClass]="{'current-tab': currentStep === -1, 'visited': !blueprintForm.invalid && blueprintForm.touched}">
          <span class="flex items-center justify-center mr-8"><span class="mat-subtitle-2 fw-700 fs-14 count flex items-center justify-center">1</span></span>
          <span class="mat-subtitle-2 fw-500 tab-name">{{ 'CREATE_SERVICE.GENERAL' | transloco }}</span>
          <span class="horizontal-line ml-12"></span>
        </div>
        <div *ngFor="let step of stepsArray" class="flex items-center justify-center" [ngClass]="{'current-tab': currentStep === step, 'visited': !installationSpecificationForms[step]?.formGroup.invalid && installationSpecificationForms[step]?.formGroup.touched}">
          <span class="flex items-center justify-center mr-8"><span class="mat-subtitle-2 fw-700 fs-14 count flex items-center justify-center">{{step + 2}}</span></span>
          <span *ngIf="stepsArray.length !== 0" class="mat-subtitle-2 fw-500 tab-name">{{installationSpecificationForms[step]?.property?.title}}</span>
          <span class="horizontal-line ml-12"></span>
        </div>
        <div *ngIf="blueprintForm" class="flex items-center justify-center" [ngClass]="{'current-tab': !showQuestionnaireSection, 'visited': summaryPageVisited}">
          <span class="flex items-center justify-center mr-8"><span class="mat-subtitle-2 fw-700 fs-14 count flex items-center justify-center">{{stepsArray?.length + 2}}</span></span>
          <span class="mat-subtitle-2 fw-500 tab-name">{{ 'CREATE_SERVICE.SUMMARY' | transloco }}</span>
        </div>
      </div>      
      <div class="flex flex-row mt-8 h-100-percent mb-20 service-section" *ngIf="blueprintForm">
        <div class="flex flex-col white-bg w-100-percent h-100-percent order-position">
          <ng-container *ngIf="showQuestionnaireSection; else showSummarySection">
            <div id="service-setup-form">
              <ng-container *ngIf="currentStep === -1">
                <form [formGroup]="blueprintForm" class="flex flex-col mat-headline-6 m-0 mb-16">
                <div class="flex flex-row">
                  <div class="flex flex-col form-field">
                    <div class="flex flex-row flex-wrap">
                      <label class="fw-700">{{ 'CREATE_SERVICE.BLUEPRINT_NAME' | transloco | uppercase }}</label>
                      <mat-icon class="icon-sm ml-160 mt--16" [matTooltip]="'CREATE_SERVICE.SERVICE_DEFINITION_NAME' | transloco"  matTooltipClass="right  pb-0  tooltip" matTooltipPosition="right" svgIcon="info" class="info-icon"></mat-icon>
                      <span class="mandatory mt--8 ml-4 mat-body-2">*</span>
                    </div>         
                    <input class="blend-border mt-4 blueprint-name"
                          [placeholder]="'CREATE_SERVICE.ENTER' | transloco: { propertyName: ('CREATE_SERVICE.BLUEPRINT_NAME_PLACEHOLDER' | transloco)}"
                          [formControl]="blueprintForm.get('name')" required [readonly]="blueprint && blueprint[0]?.name">
                    <app-error [control]="blueprintForm.get('name')"></app-error>
                    <!-- <ng-container *ngIf="!sandbox">
                      <div class="flex flex-row mt-20">
                        <label class="fw-700">{{ 'CREATE_SERVICE.SYSGEN' | transloco | uppercase }}</label>
                        <mat-icon class="icon-sm ml-4" [matTooltip]="'CREATE_SERVICE.SYSGEN_TOOLTIP' | transloco"  matTooltipClass="right  pb-0  tooltip" matTooltipPosition="right" svgIcon="info"></mat-icon>
                        <span class="mandatory mt--8 ml-4 mat-body-2">*</span>
                      </div>
                      <mat-slide-toggle color="primary" [disabled]="blueprint" [checked]="sysGenData" (change)="sysGen($event)"></mat-slide-toggle>
                    </ng-container> -->
                  </div>
                  <!-- <div class="flex flex-col form-field">
                    <label class="mb-4 fw-700">{{ 'CREATE_SERVICE.REGION' | transloco | uppercase }}</label>
                    <mat-icon class="icon-sm ml-50 mt--20 " [matTooltip]="'CREATE_SERVICE.REGION_NAME' | transloco"  matTooltipClass="right pb-0 tooltip" matTooltipPosition="right" svgIcon="info"></mat-icon>
                    <input class="blend-border mt-4"
                    [placeholder]="'CREATE_SERVICE.ENTER' | transloco: { propertyName: ('CREATE_SERVICE.REGION' | transloco)}"
                    [formControl]="blueprintForm.get('region')" required readonly>
                    <app-error [control]="blueprintForm.get('region')"></app-error>
                  </div> -->
                  <div *ngIf="supportedISBTypes" class="flex flex-col form-field">
                    <div class="flex flex-row">
                        <label class="fw-700">{{ 'CREATE_SERVICE.ISB_DATABASE' | transloco | uppercase }}</label>
                        <mat-icon class="icon-sm ml-4" [matTooltip]="'CREATE_SERVICE.ISB_DATABASE' | transloco"  matTooltipClass="right  pb-0  tooltip" matTooltipPosition="right" svgIcon="info"></mat-icon>
                        <span class="mandatory mt--8 ml-4 mat-body-2">*</span>
                    </div>
                    <mat-slide-toggle color="primary" [checked]="isbTypeSelected"  (change)="selectIsbType($event)" [disabled]="blueprint && blueprint[0]?.name || !ISBTypeSelection"></mat-slide-toggle>
                  </div>
                </div>
                </form>
              </ng-container>
              <ng-container *ngIf="currentStep > -1 && stepsArray.length !== 0">
                <app-dynamic-form *ngIf="!sandbox" [dynamicFormModel]="installationSpecificationForms[currentStep]">
                </app-dynamic-form>
                <app-sandbox-dynamic-form *ngIf="sandbox" [dynamicFormModel]="installationSpecificationForms[currentStep]">
                </app-sandbox-dynamic-form>
              </ng-container>
            </div>
          </ng-container>
          <ng-template #showSummarySection>
            <div>
              <div class="flex flex-col sumary-section mb-16">
                <div class="flex flex-row">
                  <div class="basis-full heading fs-20 fw-700 mb-16">{{ 'CREATE_SERVICE.GENERAL' | transloco }}</div>
                  <div class="flex justify-end cursor-pointer edit" (click)="goToStep(-1)">
                    <mat-icon svgIcon="edit" class="h-16 w-16 mr-4 mt--2"></mat-icon>
                    <div class="fs-16 fw-500 mt--4">{{ 'BUTTONS.EDIT' | transloco }}</div>
                  </div>
                </div>
                <div class="flex flex-row">
                  <div class="flex flex-col service-title">
                    <div class="overline-font subheading fs-14 mb-8">{{ 'CREATE_SERVICE.SERVICE_NAME' | transloco | uppercase }}</div>
                    <div class="mat-subtitle-2 blueprint-value fw-400  word-break-word">{{ this.blueprintForm.get('name').value }}</div>
                  </div>
                  <div *ngIf="supportedISBTypes"class="flex flex-col service-title">
                    <div class="overline-font subheading fs-14 mb-8">{{ 'CREATE_SERVICE.ISB_DATABASE' | transloco | uppercase }}</div>
                    <mat-slide-toggle color="primary" [checked]="isbTypeSelected" disabled></mat-slide-toggle>
                  </div>
                </div>
              </div>
              <div *ngIf="includedCapabilities?.length > 0 || optionalCapabilities?.length > 0" class="flex flex-col">
                <div class="sumary-section mb-16">
                  <div class="flex flex-row">
                    <div class="basis-full heading fs-20 fw-700 mb-24">
                      {{ 'CREATE_SERVICE.CAPABILITIES' | transloco }}</div>
                      <div class="flex justify-end cursor-pointer edit" (click)="previous()">
                        <mat-icon svgIcon="edit" class="h-16 w-16 mr-4 mt--2"></mat-icon>
                        <div class="fs-16 fw-500 mt--4">{{ 'BUTTONS.EDIT' | transloco }}</div>
                      </div>
                  </div>
                  <div class="flex flex-row w-90-percent justify-between">                    
                    <div *ngIf="includedCapabilities?.length > 0" class="flex flex-col">
                      <div class="overline-font subheading fs-14 mb-8">{{ 'CREATE_SERVICE.INCLUDED_CAPABILITIES' | transloco | uppercase }}</div>
                        <div class="flex flex-wrap">
                        <span *ngFor="let capability of includedCapabilities; let i = index">
                          <span class="mat-body-1">{{ capability?.displayName ? (capability?.displayName) : (capability?.name) }}</span>
                          <span *ngIf="i !== (includedCapabilities?.length - 1)" class="mr-4">,</span>
                        </span>
                      </div>
                    </div>
                    <div *ngIf="optionalCapabilities?.length > 0" class="flex flex-col">
                      <div class="overline-font subheading fs-14 mb-8">{{ 'CREATE_SERVICE.OPTIONAL_CAPABILITIES' | transloco | uppercase }}</div>
                      <div class="flex flex-wrap">
                        <span *ngFor="let capability of optionalCapabilities; let i = index">
                          <span class="mat-body-1">{{ capability?.displayName ? (capability?.displayName) : (capability?.name) }}</span>
                          <span *ngIf="i !== (optionalCapabilities?.length - 1)" class="mr-4">,</span>
                        </span>
                      </div>
                    </div>
                    <div *ngIf="additionalCapabilties?.length > 0" class="flex flex-col">
                      <div class="overline-font subheading fs-14 mb-8">{{ 'CREATE_SERVICE.ADDITIONAL_CAPABILITIES' | transloco | uppercase }}</div>
                      <div class="flex flex-wrap">
                        <span *ngFor="let capability of additionalCapabilties; let i = index">
                          <span class="mat-body-1">{{ capability?.displayName ? (capability?.displayName) : (capability?.name) }}</span>
                          <span *ngIf="i !== (additionalCapabilties?.length - 1)" class="mr-4">,</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="exchangeAdapters?.length > 0" class="sumary-section mb-16">
                  <div class="flex flex-row">
                    <div class="basis-full overline-font subheading fs-14 pt-4">{{ 'CREATE_SERVICE.EXCHANGE_ADAPTERS' | transloco | uppercase }}</div>
                    <div class="flex justify-end cursor-pointer edit" (click)="exchangePage()">
                      <mat-icon svgIcon="edit" class="h-16 w-16 mr-4 mt--2"></mat-icon>
                      <div class="fs-16 fw-500 mt--4">{{ 'BUTTONS.EDIT' | transloco }}</div>
                    </div>
                  </div>
                  <div class="flex flex-wrap">
                    <span *ngFor="let capability of exchangeAdapters; let i = index">
                      <span class="mat-body-1">{{ capability?.displayName ? (capability?.displayName) : (capability?.name) }}</span>
                      <span *ngIf="capability?.nestedSelected?.length > 0">
                        (<span *ngFor="let additional of capability?.nestedSelected; let n = index">
                          <span>{{ additional?.displayName ? (additional?.displayName) : (additional?.name) }}</span><span *ngIf="n !== (capability?.nestedSelected?.length - 1)" class="mr-4">,</span>
                        </span>)
                      </span>
                      <span *ngIf="i !== (exchangeAdapters?.length - 1)" class="mr-8">,</span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="flex flex-col sumary-section mb-16"
                  *ngFor="let installationSpecificationForm of installationSpecificationForms;let i = index">
                <div class="flex flex-row">
                  <div class="basis-full heading fs-20 fw-700 mb-24">
                    {{ installationSpecificationForm.property.title }}</div>
                  <div class="flex justify-end cursor-pointer edit" (click)="goToStep(i)">
                    <mat-icon svgIcon="edit" class="h-16 w-16 mr-4 mt--2"></mat-icon>
                    <div class="fs-16 fw-500 mt--4">{{ 'BUTTONS.EDIT' | transloco }}</div>
                  </div>
                </div>
                <app-questionnaire-summary [dynamicFormModel]="installationSpecificationForm" [sandbox]="sandbox">
                </app-questionnaire-summary>
              </div>
            </div>
          </ng-template>
          <span class="flex-auto"></span>
        </div>
      </div>
    </div>
  </div>
  <span class="flex-auto"></span>
  <div class="summary-header max-width-lg mt-auto">
    <div class="flex flex-row justify-between max-width">
      <div class="flex flex-row">
      </div>
      <div class="flex flex-row">
        <div class="flex justify-items-center items-center ml-auto cursor-pointer mr-50" (click)="currentStep === -1 ? exchangePage() : goToStep(currentStep - 1)">
          <mat-icon class="icon-sm mr-8" svgIcon="arrow_back"></mat-icon>
          <span class="mat-subtitle-2 fw-700 cursor-pointer">{{ 'BUTTONS.PREVIOUS' | transloco }}</span>
        </div>
        <button (click)="goBack()" class="flex justify-items-center items-center cancel-btn ml-auto mr-26 pr-16 pl-16 pt-8 pb-8">
          {{ 'BUTTONS.CANCEL' | transloco }}
        </button>
        <button
          *ngIf="showQuestionnaireSection || (stepsArray.length !== 0 && currentStep < stepsArray.length - 1); else showSetupButton"
          class="flex justify-items-center spacing items-center mossgreen primary-fg pr-16 pl-16 pt-8 pb-8" type="button"
          (click)="goToStep(currentStep + 1)">{{ 'BUTTONS.NEXT' | transloco }}
        </button>
        <ng-template #showSetupButton>
          <div class="button-container">
            <div class="spinner-container" *ngIf="serviceLoader">
              <mat-spinner diameter="24"></mat-spinner>
            </div>
            <button class="flex justify-center items-center items-center mossgreen primary-fg" type="button" [disabled]="serviceLoader" (click)="setup()">
              <span *ngIf="!blueprintId">{{sandbox ? ('CREATE_SERVICE.CREATE_SANDBOX' | transloco) : ('BUTTONS.SUBMIT' | transloco) }}</span>
              <span *ngIf="blueprintId">{{ sandbox ? ('CREATE_SERVICE.UPDATE_SANDBOX' | transloco) : ('CREATE_SERVICE.UPDATE_SERVICE' | transloco) }}</span>
            </button>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
